/**
 * 西班牙
 */
export default {
  customProduct: {
    CustomProduct: 'producto personalizado',
    Status: 'Estado',
    SampleFee: 'tasa de muestra',
    inputPlaceholder: 'buscar por nombre de producto o número de requisito',
    AddNewDemand: 'añadir nuevos requisitos',
    Product: 'producto',
    AddedTime: 'añadir tiempo',
    DemandStatus: 'Estado de la demanda',
    PaymentStatus: 'Estado de pago',
    Action: 'acción',
    Details: 'detalles',
    DemandNo: 'Request No',
    More: 'más',
    Edit: 'editor',
    PaySampleFee: 'pay samplefee',
    PayNow: 'Pago inmediato',
    PaymentRecords: 'payment Records',
    Cancel: 'Cancelar',
    Unreceived: 'no recibido',
    Received: 'recibido',
    Completed: 'hecho',
    Canceled: 'Cancelar',
    Published: 'publicado',
    Unpaid: 'no pagado',
    Paid: 'pagar',
    CreatedTime: 'Crear tiempo',
    TransactionTime: 'Tiempo de negociación',
    Amount: 'Cantidad',
    PaySampleFeeTips: 'Por favor, pague la tasa de muestra, la orden de muestra se puede generar después del pago',
    PaymentAmount: 'Importe del pago',
    PaymentMethod: 'Método de pago',
    CreditCard: 'Tarjeta de crédito',
    Balance: 'Equilibrio',
    Confirm: 'Confirmar',
    transactionError: 'Generar excepción de orden de transacción',
    CustomProcess: 'Proceso de personalización',
    stepTitle1: 'Envíe su solicitud personalizada',
    stepDescription1_1: 'Click',
    stepDescription1_2: 'Botón, rellene la información del producto que necesita personalizar.',
    stepTitle2: 'Póngase en contacto con nuestro representante de servicio al cliente',
    stepDescription2: 'Nuestro representante de servicio al cliente le enviará un correo electrónico de contacto para comunicarle sus necesidades personalizadas.',
    stepTitle3: 'Pago y entrega de muestras',
    stepDescription3: 'Kakaclo enviará las muestras al cliente para su confirmación.',
    stepTitle4: 'Confirmación de la muestra y producción formal',
    stepDescription4: 'Después de la confirmación de la muestra, puede ponerse en contacto con nuestro representante de servicio al cliente para iniciar la producción formal.',
    Remark: 'Comentarios',
    TotalAmount: 'Importe total'
  },
  customDetail: {
    Back: 'Vuelve aquí.',
    AddNewDemand: 'Aumento de la demanda',
    Style: 'Estilo',
    ProductName: 'Nombre del producto',
    ProductNamePlace: 'Una camiseta, falda, chaqueta, etc.',
    ContactEmail: 'Correo electrónico de contacto',
    ContactEmailPlace: 'Introduzca un número de correo electrónico válido',
    PhoneNumber: 'Número de teléfono',
    EstimatedOrderQuantity: 'Cantidad estimada de pedidos',
    EstimatedOrderQuantityPlace: 'Cantidad de productos pedidos',
    ColorQuantity: 'Cantidad cromática',
    ColorQuantityPlace: '¿Cuántos colores quieres personalizar?',
    SizeQuantity: 'Tamaño (por color)',
    SizeQuantityPlace: '¿Cuántos tamaños quieres personalizar?',
    ReferenceLinking: 'Enlaces de referencia',
    ReferenceLinkingTooltip: 'Un enlace al producto que desea personalizar.',
    ReferenceLinkingPlace: 'Introduzca la dirección del enlace',
    Description: 'Descripción',
    DescriptionPlace: 'Por favor, díganos los detalles del producto que desea personalizar.',
    Image: 'Imagen',
    ImageTip: '(las imágenes sólo pueden mostrar hasta 10.)',
    Fabric: 'Tela',
    Category: 'Categoría',
    FabricName: 'Nombre del tejido',
    CategoryPlace: 'Lino, algodón, etc.',
    Weight: 'Peso (g)',
    WeightPlace: 'Peso de la tela',
    Composition: 'Composición',
    Add: 'Más',
    Accessories: 'Accesorios',
    Printing: 'Impresión',
    PrintingType: 'Tipo de impresión',
    PrintingTypePlace: 'Impresión de pigmentos, etc.',
    ReferenceLinkingPlace2: 'Enlaces de referencia para esquemas',
    Width: 'Ancho(cm)',
    WidthPlace: 'Anchura del patrón',
    Length: 'Longitud(cm)',
    LengthPlace: 'Longitud del patrón',
    Position: 'Posición',
    PositionPlace: 'Posición de impresión en la ropa',
    Description2: 'Descripción del patrón',
    Embroidery: 'Bordado',
    PrintingType2: 'Calcomanías, parches de bordado, etc.',
    Color: 'Color',
    Washing: 'Lavado',
    WashingType: 'Tipo de lavado',
    WashingTypePlace: 'Lavado de piedra, lavado enzimático, etc.',
    PositionPlace2: '¿Qué lugar necesita limpieza?',
    OtherTechnology: 'Otras tecnologías',
    TechnologyName: 'Nombre técnico',
    Submit: 'Obediencia',
    InputContent: 'Contenido de entrada',
    edit: 'Editar',
    detail: 'Detalles',
    onlyPictures: 'Sólo se pueden subir imágenes',
    pictureSize: 'Soporte máximo de imagen 5m, soporte de formato: jpg, PNG, GIF'
  },
  touristCustom: {
    SubmittedSuccessfully: 'Presentación exitosa',
    tip1: 'Haga clic en el servicio al cliente de contacto de abajo para comunicar sus necesidades personalizadas',
    tip2: 'O esperar pacientemente a que el servicio al cliente se ponga en contacto con usted',
    back: 'Atrás',
    CustomProduct: 'Productos personalizados',
    AddedTime: 'Tiempo extra',
    DemandNo: 'Número de demanda',
    Home: 'Hogar'
  }
}
